export default __webpack_public_path__ + "static/media/featured-newport.22fa7b72.webp";